import { Box, Button, Grid, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import { SlideAnimationContext } from "contexts/SlideAnimation";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { OnboardAction } from "schemas/dashboard";
import { routes } from "schemas/routes";

import { trackEvent } from "utils/tracking";
import { useTracking } from "utils/useTracking";

const styles = {
  title: { textAlign: "center", mb: 3 },
  mainIcon: { pr: 2, color: "secondary.dark" },
  container: { maxWidth: 550, mb: 2 },
  text: { fontSize: 15, textAlign: "center" },
  bullet: { listStyleType: "none" },
  verifiedIcon: { pr: 1, color: green[500] },
  pitchIcon: { pr: 1, color: "info.main" },
  followUpIcon: { pr: 1, color: green[700] },
  trackIcon: { pr: 1, color: "primary.main" },
};

const CongratsComplete = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const slideContext = useContext(SlideAnimationContext);
  const { trackUserHasOnboarded } = useTracking();

  const handleNext = async () => {
    if (slideContext) {
      await slideContext.slideOutUp();
      slideContext.slideInUp();
    }
    trackEvent("Onboarding Form - Next Button Pressed", {
      page: "completePage",
      route: location.pathname,
    });
    trackUserHasOnboarded(OnboardAction.COMPLETE_PAGE);
    navigate(`/${routes.home}`);
  };

  return (
    <>
      <Typography variant="h3" gutterBottom sx={styles.title}>
        🎉 Congratulations!
      </Typography>
      <Box display="flex" justifyContent="center">
        <Box sx={styles.container}>
          <Typography sx={styles.text}>
            You've completed onboarding and connected your Instagram to Bento.
            Let's keep going and start pitching!
          </Typography>
        </Box>
      </Box>

      <Grid container justifyContent="center" sx={{ mt: 4 }}>
        <Grid item xs="auto">
          <Button disableElevation variant="contained" onClick={handleNext}>
            Next
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default CongratsComplete;
